import { useManagedModalLifecycleContext } from '#pplx/frontend/aether/components/Modal/context/ManagedModalLifecycleContext.js';
import { useCallback, useLayoutEffect, useRef } from 'react';
export function useModalExitAnimation(isOpen) {
    const manager = useManagedModalLifecycleContext();
    const effectiveIsOpen = isOpen && manager?.status !== 'exiting';
    const isExitPendingRef = useRef(effectiveIsOpen);
    useLayoutEffect(() => {
        if (effectiveIsOpen) {
            isExitPendingRef.current = true;
        }
    }, [effectiveIsOpen]);
    const handleExitComplete = useCallback(() => {
        isExitPendingRef.current = false;
        manager?.onExitComplete();
    }, [manager]);
    // Register in the layout phase so the parent renderer observes this capability
    // before its same-commit fallback can remove a modal without an exit animation.
    useLayoutEffect(() => manager?.registerExitAnimation(() => isExitPendingRef.current), [manager]);
    return {
        isOpen: effectiveIsOpen,
        onExitComplete: manager ? handleExitComplete : undefined,
    };
}
//# sourceMappingURL=useModalExitAnimation.js.map